import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { SideMenuFragment } from '../side-menu-fragment/side-menu.fragment';

@Component({
  selector: 'frg-side-menu-container',
  templateUrl: './side-menu-container.fragment.html',
  styleUrls: ['./side-menu-container.fragment.scss']
})
export class SideMenuContainerFragment {
  private _sidebar: SideMenuFragment;

  constructor() { }

  public addSidebar(sidebar: SideMenuFragment): void {
    this._sidebar = sidebar;
  }
}
